<template>
  <div class="d-flex flex-row align-items-center">
    <div class="dropdown">
      <button class="btn dropdown-toggle border rounded" type="button"
        id="dropdownMenuFromTimeButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="isChecked || inActive"
        >
        {{ selectedFromTime.label }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuFromTimeButton"
        style="overflow-y: scroll; height: 200px;">
        <template v-for="(fromTime, index) in createFromTimeDropdwonMenu" :key="index">
          <li><button class="dropdown-item fromDropdownBtn" v-if="activeSelectTime(fromTime)" @click="setSelectedFromTime(fromTime)" :value="fromTime.value" :id="'fromTimeBtn-' + fromTime.value">{{fromTime.label}}</button></li>
        </template>
      </ul>
    </div>
    <div class="h4 ms-2 me-2">～</div>
    <div class="dropdown">
      <button class="btn dropdown-toggle border rounded" type="button"
        id="dropdownMenuFromTimeButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="isChecked || inActive"
        >
        {{ selectedToTime.label }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuFromTimeButton"
        style="overflow-y: scroll; height: 200px;">
        <template v-for="(toTime, index) in createToTimeDropdwonMenu" :key="index" >
          <li><button class="dropdown-item" @click="setSelectedToTime(toTime)" :value="toTime.value" :id="'toTimeBtn-' + toTime.value">{{toTime.label}}</button></li>
        </template>
      </ul>
    </div>
    <div class="form-check mx-4" v-if="isDisplayCheckbox">
      <input class="form-check-input" type="checkbox" @click="switchChecked(!isChecked)" id="flexCheckChecked" v-model="isChecked" :disabled="inActive">
      <label class="form-check-label" for="flexCheckChecked">
        1日貸切
      </label>
    </div>
  </div>
</template>

<script>
import Const from '../const'
import axios from 'axios'
import reserveMixin from '@/mixins/reserveMixin.js'


export default {
  name: 'ReserveFromToTime',
  props: {
    restoreSelectedFromTime: { default: { 'label': '', 'value': null} },
    restoreSelectedToTime: { default: { 'label': '', 'value': null} },
    reservedTimes: { default: [] },
    selectedDate: { default: "" },
    enabled: { default: false },
    isDisabled: { default: false }
  },
  emits: ['catcSelectedFromTime', 'catcSelectedToTime', 'changeDisabled'],
  data: () => ({
    serverTime: new Date(),
    // 予約時間（開始）ドロップダウン用のデータ
    reserveFromTimes: [
      { label: '10:00', value: 1000 }, { label: '10:15', value: 1015 }, { label: '10:30', value: 1030 }, { label: '10:45', value: 1045 },
      { label: '11:00', value: 1100 }, { label: '11:15', value: 1115 }, { label: '11:30', value: 1130 }, { label: '11:45', value: 1145 },
      { label: '12:00', value: 1200 }, { label: '12:15', value: 1215 }, { label: '12:30', value: 1230 }, { label: '12:45', value: 1245 },
      { label: '13:00', value: 1300 }, { label: '13:15', value: 1315 }, { label: '13:30', value: 1330 }, { label: '13:45', value: 1345 },
      { label: '14:00', value: 1400 }, { label: '14:15', value: 1415 }, { label: '14:30', value: 1430 }, { label: '14:45', value: 1445 },
      { label: '15:00', value: 1500 }, { label: '15:15', value: 1515 }, { label: '15:30', value: 1530 }, { label: '15:45', value: 1545 },
      { label: '16:00', value: 1600 }, { label: '16:15', value: 1615 }, { label: '16:30', value: 1630 }, { label: '16:45', value: 1645 },
      { label: '17:00', value: 1700 },
    ],
    // 予約時間（終了）ドロップダウン用のデータ
    reserveToTimes: [{ label: '10:15', value: 1015 }, { label: '10:30', value: 1030 }, { label: '10:45', value: 1045 },
      { label: '11:00', value: 1100 }, { label: '11:15', value: 1115 }, { label: '11:30', value: 1130 }, { label: '11:45', value: 1145 },
      { label: '12:00', value: 1200 }, { label: '12:15', value: 1215 }, { label: '12:30', value: 1230 }, { label: '12:45', value: 1245 },
      { label: '13:00', value: 1300 }, { label: '13:15', value: 1315 }, { label: '13:30', value: 1330 }, { label: '13:45', value: 1345 },
      { label: '14:00', value: 1400 }, { label: '14:15', value: 1415 }, { label: '14:30', value: 1430 }, { label: '14:45', value: 1445 },
      { label: '15:00', value: 1500 }, { label: '15:15', value: 1515 }, { label: '15:30', value: 1530 }, { label: '15:45', value: 1545 },
      { label: '16:00', value: 1600 }, { label: '16:15', value: 1615 }, { label: '16:30', value: 1630 }, { label: '16:45', value: 1645 },
      { label: '17:00', value: 1700 }, { label: '17:15', value: 1715 }, { label: '17:30', value: 1730 }, { label: '17:45', value: 1745 },
      { label: '18:00', value: 1800 },
    ],
    selectedFromTime: { 'label': '', 'value': null },
    selectedToTime: { 'label': '', 'value': null },
    isChecked: false,
    inActive: false
  }),
  methods: {
    async getServerTime() {
      
      const response = await axios.get(Const.BASE_URL + "/fetch-server-time",{
        headers: {
        "Authorization": this.$store.getters.token,
        "Content-Type": "application/json"
      }
      })
      this.serverTime = new Date(response.data)
      return this.serverTime
    },
    today(){
      const now = this.serverTime
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, "0")
      const day = String(now.getDate()).padStart(2, "0")
      return year + "-" + month + "-" + day
    },
    time(){
      const now = this.serverTime
      const hour = String(now.getHours()).padStart(2, "0")
      const min = String(now.getMinutes()).padStart(2, "0")
      return hour + min
    },
    setSelectedFromTime: function(val) {
      // console.log("setSelectedFromTime");
      this.selectedFromTime = val;
      this.$emit('catcSelectedFromTime', val);
    },
    setSelectedToTime: function(val) {
      // console.log("setSelectedToTime");
      this.selectedToTime = val;
      this.$emit('catcSelectedToTime', val);
    },
    // 予約時間単位
    getReserveTimeUnit: function() {
      var timeUnit = 100;
      return timeUnit;
    },
    activeSelectTime(fromTime) {

      if (this.selectedDate == this.today() && Number(fromTime.value) <= Number(this.time())) {
        return false
      } else {
        if (this.selectedFromTime.value == null) {
          this.setSelectedFromTime(fromTime)
        }
        return true
      }
    },
    switchChecked(val) {
      if (val) {
        this.setSelectedFromTime({ label: '10:00', value:  1000 })
        setTimeout(function() {
          this.setSelectedToTime({ label: '18:00', value: 1800 })
        }.bind(this), 100)
      } else {
        this.setSelectedFromTime({ label: '10:00', value:  1000 })
        this.setSelectedToTime({ label: '12:00', value: 1200 })
      }
    }
  },
  computed: {
    // 予約時間（開始）の選択可能ドロップダウンの生成
    createFromTimeDropdwonMenu: function() {
      // console.log("createFromTimeDropdwonMenu:");
      // 無効の場合は空を返却
      if (!this.enabled) {
        this.setSelectedFromTime({ 'label': '', 'value': null });
        return [];
      }
      // フリーはそのまま返却
      // if (this.isFree()) {
      //   this.setSelectedFromTime(!this.restoreSelectedFromTime.label ?
      //     this.reserveFromTimes[0] : this.restoreSelectedFromTime);
      //   return this.reserveFromTimes;
      // }
      // 会議室、大広間用
      var timeRange = [];
      // 最終予約開始時間の算出
      var lastTime = 1800 - this.getReserveTimeUnit();
      // 最終予約開始時間より後は除外
      var reserveFromTimes = this.reserveFromTimes.filter((fromTime) => {
        return fromTime.value > lastTime ? false : true;
      });
      // 予約開始する指定時間前の時間を算出
      this.reservedTimes.forEach((ele) => ele['oneHourAgo'] = ele.start - this.getReserveTimeUnit());
      for (var fromTime of reserveFromTimes) {
        var excludedFlg =false;
        for (var reservedTime of this.reservedTimes) {
          if (reservedTime.end < fromTime.value) {
            continue;
          }
          // 予約済み時間の範囲は除外
          if (reservedTime.start < fromTime.value && fromTime.value < reservedTime.end) {
            excludedFlg = true;
            break;
          }
          // 指定時間以上の予約がとれない場合は除外
          var flg = (reservedTime.oneHourAgo < fromTime.value && fromTime.value < reservedTime.end)
          if (flg) {
            excludedFlg = true;
            break;
          }
          // 10時台に予約が入った場合は除外
          if (flg && (reservedTime.oneHourAgo < fromTime.value && reservedTime.oneHourAgo < 1000 )) {
            excludedFlg = true;
            break;
          }
        }
        if (!excludedFlg) {
          timeRange.push(fromTime);
        }
      }
      
      if (!this.restoreSelectedFromTime.label) {
        // デフォルト選択値の設定
        // this.setSelectedFromTime(!timeRange.length ? { 'label': '', 'value': null } : timeRange[0]);
        this.setSelectedFromTime({ 'label': '', 'value': null })
      } else {
        // 前回選択値がドロップダウンに存在しているか確認
        var findFrom = timeRange.find((ele) => ele.label == this.restoreSelectedFromTime.label);
        if (!findFrom) {
          // 見つからなかった場合デフォルト値を設定
          // this.setSelectedFromTime(!timeRange.length ? { 'label': '', 'value': null } : timeRange[0]);
          this.setSelectedFromTime({ 'label': '', 'value': null })
        } else {
          // 前回選択値の復元
          this.setSelectedFromTime(this.restoreSelectedFromTime);
        }
      }
      return timeRange;
    },
    // 予約時間（終了）の選択可能ドロップダウンの生成
    createToTimeDropdwonMenu: function() {
      // console.log("createToTimeDropdwonMenu:");
      // 無効または予約時間（開始）未選択の場合は空を返却
      if (!this.enabled || !this.selectedFromTime.value) {
        this.setSelectedToTime({ 'label': '', 'value': null });
        return [];
      }
      var reservedTimes = this.reservedTimes;
      var reserveToTimes = this.reserveToTimes;
      var timeRange = [];
      // フリーの場合
      if (this.isFree()) {
        reservedTimes = [];
      } else {
        // 指定時間単位の選択肢以外を除外する
        // console.log(reserveToTimes);
        reserveToTimes = reserveToTimes.filter((time) => {
          const diffValue = time.value - this.selectedFromTime.value
          if (diffValue && diffValue % this.getReserveTimeUnit() === 0) {
            return true
          }
          else if (this.isHall()) {
            if (this.selectedFromTime.value === 1000 && time.value === 1800) {
              return true
            }
          }
          return false;
        });
        // console.log(reserveToTimes);
      }

      for (var toTime of reserveToTimes) {
        // 選択済み予約時間（開始）より前は除外
        if (toTime.value <= this.selectedFromTime.value) {
          continue;
        }
        var excludedFlg =false;
        for (var reservedTime of reservedTimes) {
          // 選択済み予約時間（開始） < 予約済み開始時間 < 予約時間（終了）に該当する予約時間（終了）を除外
          if ((this.selectedFromTime.value < reservedTime.start)
              && (reservedTime.start < toTime.value)) {
            excludedFlg = true;
            break;
          }
        }
        if (!excludedFlg) {
          timeRange.push(toTime);
        }
      }

      if (!this.restoreSelectedToTime.label) {
        // デフォルト選択値の設定
        if (this.isFree()) {
          this.setSelectedToTime(!timeRange.length ? { 'label': '', 'value': null } : timeRange[timeRange.length - 1]);
        } else {
          this.setSelectedToTime(!timeRange.length ? { 'label': '', 'value': null } : timeRange[0]);
        }
      } else {
        // 前回選択値がドロップダウンに存在しているか確認
        var findFrom = timeRange.find((ele) => ele.value == this.restoreSelectedToTime.value);
        if (!findFrom) {
          // 見つからなかった場合デフォルト値を設定
          if (this.isFree()) {
            this.setSelectedToTime(!timeRange.length ? { 'label': '', 'value': null } : timeRange[timeRange.length - 1]);
          } else {
            this.setSelectedToTime(!timeRange.length ? { 'label': '', 'value': null } : timeRange[0]);
          }
        } else {
          // 前回選択値の復元
          this.setSelectedToTime(this.restoreSelectedToTime);
        }
      }

      return timeRange;
    },
    // チェックボックスの表示・非表示の判定
    isDisplayCheckbox: function() {
      const reservedTimes = this.reservedTimes
      // 大広間なら表示
      if (this.isHall()) {
        // 日付が未選択なら非表示
        if (this.selectedDate == "") {
          return false
        }
        if (this.selectedDate == this.today()) {
          // 現時刻が10時以降なら非表示
          if (1000 <= Number(this.time())) {
            return false
          }
        }
        // 同じ日に予約がなければ表示
        if (reservedTimes.length == 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
  },
  watch: {
    selectedDate(val) {
      if (val) {
        this.isChecked = false
      }
    }
  },
  async created(){
    await this.getServerTime()
  },
  mixins: [reserveMixin],
}
</script>